/*
 * @Author: 戴旭
 * @Date: 2023-02-17 16:05:34
 * @LastEditTime: 2023-02-17 16:11:57
 * @LastEditors: 戴旭
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\cloud-visit\cloud-visit\index.js
 * 云拜访
 */
import contextManageRouter from './module/contextManageRouter'
import dataManageRouter from './module/dataManageRouter'
import otherRouter from './module/otherRouter'

const cloudVisitRouter = [].concat(contextManageRouter, dataManageRouter, otherRouter)

export default cloudVisitRouter
